import { render } from "./FeedbackNotification.vue?vue&type=template&id=415539ee"
import script from "./FeedbackNotification.vue?vue&type=script&lang=js"
export * from "./FeedbackNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__